import React, { useState } from 'react';
import { Camera, ExternalLink, Mail, Phone } from 'lucide-react';
import BrandLogo from './BrandLogo';
import Modal from './Modal';
import PrivacyModal from './PrivacyPolicyModal';

function Footer() {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  return (
    <footer className="border-t border-slate-200/80 bg-slate-950 text-white">
      <div className="h-1.5 color-strip" />
      <div className="container-page grid gap-10 py-12 md:grid-cols-[1.1fr_1fr_0.8fr]">
        <div>
          <div className="flex items-center gap-3">
            <BrandLogo className="h-12 w-12 rounded-xl bg-white" />
            <div>
              <p className="font-semibold tracking-tight">Clear Horizons</p>
              <p className="text-sm text-slate-400">Inclusive talent platform</p>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-6 text-slate-400">
            Helping blind and visually impaired professionals showcase skills and connect with
            meaningful employment opportunities.
          </p>
        </div>

        <div>
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-slate-300">
            Contact
          </h2>
          <div className="mt-4 space-y-3 text-sm text-slate-300">
            <a
              href="mailto:info@clearhorizons.in"
              className="focus-ring flex items-center gap-3 rounded-lg transition hover:text-white"
            >
              <Mail className="h-4 w-4 text-blue-300" />
              info@clearhorizons.in
            </a>
            <a
              href="tel:+919717433853"
              className="focus-ring flex items-center gap-3 rounded-lg transition hover:text-white"
            >
              <Phone className="h-4 w-4 text-blue-300" />
              +91 9717433853
            </a>
            <a
              href="tel:+919931512282"
              className="focus-ring flex items-center gap-3 rounded-lg transition hover:text-white"
            >
              <Phone className="h-4 w-4 text-blue-300" />
              +91 9931512282
            </a>
          </div>
        </div>

        <div>
          <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-slate-300">
            Follow
          </h2>
          <div className="mt-4 flex gap-3">
            <a
              href="https://www.instagram.com/clearhorizons4/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Clear Horizons on Instagram"
              className="focus-ring flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-300 transition hover:-translate-y-0.5 hover:bg-white/10 hover:text-white"
            >
              <Camera className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/clear-horizons1/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Clear Horizons on LinkedIn"
              className="focus-ring flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-slate-300 transition hover:-translate-y-0.5 hover:bg-white/10 hover:text-white"
            >
              <ExternalLink className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-page flex flex-col gap-3 py-5 text-sm text-slate-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Clear Horizons. All rights reserved.</p>
          <div className="flex gap-4">
            <button
              type="button"
              onClick={() => setIsTermsModalOpen(true)}
              className="focus-ring rounded-lg transition hover:text-white"
            >
              Terms
            </button>
            <button
              type="button"
              onClick={() => setIsPrivacyModalOpen(true)}
              className="focus-ring rounded-lg transition hover:text-white"
            >
              Privacy
            </button>
          </div>
        </div>
      </div>

      <Modal show={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} />
      <PrivacyModal show={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} />
    </footer>
  );
}

export default Footer;
